/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Plans_3Inputs */

const da_terms_plans_3 = /** @type {(inputs: Terms_Plans_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle priser er uden moms. Moms (25 % i Danmark) lægges til, når du betaler.`)
};

/** @type {(inputs: Terms_Plans_3Inputs) => LocalizedString} */
const en_terms_plans_3 = da_terms_plans_3;

/**

* @param {Terms_Plans_3Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_plans_3 = /** @type {((inputs?: Terms_Plans_3Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Plans_3Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_plans_3(inputs)
	return /** @type {LocalizedString} */ ("Alle priser er uden moms. Moms (25 % i Danmark) lægges til, når du betaler.")
});